module.exports = __webpack_public_path__ + "static/img/wxXCX.407c983.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wxXCX.jpg
// module id = CnAR
// module chunks = 202